// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_rightPanel__5m\\+tG {
  display: flex;
  flex-direction: column;
  width: 170px;
  padding: 8px 16px 16px 0;
  background: transparent;
  position: fixed;
  right: 16px;
  top: 100px;
  bottom: 16px;
  transition: width 0.3s ease;
}
@media (max-width: 767px) {
  .styles_rightPanel__5m\\+tG {
    width: 60px;
  }
}
.styles_rightPanel__5m\\+tG.styles_sidebarCollapsed__lAlpW {
  width: 60px;
}
.styles_rightPanel__5m\\+tG.styles_relative__Mf9JZ {
  position: relative;
  right: auto;
  top: auto;
  bottom: auto;
  flex-shrink: 0;
  height: auto;
  width: 360px;
}
.styles_rightPanel__5m\\+tG.styles_relative__Mf9JZ.styles_sidebarCollapsed__lAlpW {
  width: 60px;
}`, "",{"version":3,"sources":["webpack://./src/components/right-panel/styles.module.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,wBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,2BAAA;AAAF;AAGE;EAbF;IAcI,WAAA;EAAF;AACF;AAGE;EACE,WAAA;AADJ;AAKE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;AAHJ;AAMI;EACE,WAAA;AAJN","sourcesContent":["@import \"mixins\";\n.rightPanel {\n  display: flex;\n  flex-direction: column;\n  width: 170px;\n  padding: 8px 16px 16px 0;\n  background: transparent;\n  position: fixed;\n  right: 16px;\n  top: 100px; // Below header\n  bottom: 16px; // Extend to bottom with padding\n  transition: width 0.3s ease;\n\n  // Collapse on mobile\n  @media (max-width: 767px) {\n    width: 60px;\n  }\n\n  // When sidebar is collapsed to icons\n  &.sidebarCollapsed {\n    width: 60px; // Just enough for icon sidebar\n  }\n\n  // On calendar page, use relative positioning and full width\n  &.relative {\n    position: relative;\n    right: auto;\n    top: auto;\n    bottom: auto;\n    flex-shrink: 0;\n    height: auto;\n    width: 360px;\n\n    // When sidebar is collapsed on calendar page\n    &.sidebarCollapsed {\n      width: 60px; // 60px (icon sidebar) + 360px (chatbot)\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rightPanel": `styles_rightPanel__5m+tG`,
	"sidebarCollapsed": `styles_sidebarCollapsed__lAlpW`,
	"relative": `styles_relative__Mf9JZ`
};
export default ___CSS_LOADER_EXPORT___;
